module.exports = __webpack_public_path__ + "img/entrega.6ece0d8e.svg";